module.exports = __webpack_public_path__ + "static/img/comper.a9881df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comper.png
// module id = HtxE
// module chunks = 1